/******/ (() => {
  // webpackBootstrap
  var __webpack_exports__ = {};
  window.PXUTheme.jsAjaxCart = {
    init: function ($section) {
      // Add settings from schema to current object
      window.PXUTheme.jsAjaxCart = $.extend(
        this,
        window.PXUTheme.getSectionData($section)
      );

      if (isScreenSizeLarge() || this.cart_action == "drawer") {
        this.initializeAjaxCart();
      } else {
        this.initializeAjaxCartOnMobile();
      }

      if (this.cart_action == "drawer") {
        this.ajaxCartDrawer = $("[data-ajax-cart-drawer]");

        $(document).on("click", "[data-ajax-cart-trigger]", function (e) {
          e.preventDefault();
          window.PXUTheme.jsAjaxCart.showDrawer();

          return false;
        });
      } else if (this.cart_action == "mini_cart") {
        this.showMiniCartOnHover();
      }

      $(document).on("click", ".ajax-submit", function (e) {
        e.preventDefault();
        const $addToCartForm = $(this).closest("form");
        window.PXUTheme.jsAjaxCart.addToCart($addToCartForm);

        return false;
      });

      $(document).on("click", "[data-ajax-cart-delete]", function (e) {
        e.preventDefault();
        const lineID = $(this).parents("[data-line-item]").data("line-item");
        window.PXUTheme.jsAjaxCart.removeFromCart(lineID);

        if (window.PXUTheme.jsCart) {
          window.PXUTheme.jsCart.removeFromCart(lineID);
        }

        return false;
      });

      // Add event listener for selling plan changes
      $(document).on("sellingPlanChanged", function (event) {
        window.PXUTheme.jsAjaxCart.handleSellingPlanChange(
          event.originalEvent.detail
        );
      });

      // Add event listener for subscription toggle changes
      $(document).on("change", ".subscription-toggle", function (e) {
        window.PXUTheme.jsAjaxCart.handleSubscriptionToggle(e.target);
      });

      // Add event listener for selling plan dropdown changes
      $(document).on(
        "change",
        ".selling-plan-selector, .ajax-cart__selling-plan-select",
        function (e) {
          window.PXUTheme.jsAjaxCart.handleSellingPlanDropdownChange(e.target);
        }
      );

      // Add event listener for gift recipe selection changes
      $(document).on("change", "#preferred-gift", function (e) {
        window.PXUTheme.jsAjaxCart.handleGiftRecipeChange(e.target);
      });

      $(document).on("click", "[data-ajax-cart-close]", function (e) {
        e.preventDefault();
        window.PXUTheme.jsAjaxCart.hideDrawer();
        window.PXUTheme.jsAjaxCart.hideMiniCart();

        return false;
      });
    },
    showMiniCartOnHover: function () {
      const $el = $("[data-ajax-cart-trigger]");

      $el.hover(
        function () {
          if (
            window.PXUTheme.theme_settings.header_layout == "centered" &&
            $(".header-sticky-wrapper").hasClass("is-sticky")
          ) {
            $(".header-sticky-wrapper [data-ajax-cart-trigger]").addClass(
              "show-mini-cart"
            );
          } else {
            $el.addClass("show-mini-cart");
          }
        },
        function () {
          $el.removeClass("show-mini-cart");
        }
      );
    },
    hideMiniCart: function () {
      if (this.cart_action != "mini_cart") return false;
      const $el = $("[data-ajax-cart-close]").parents(
        "[data-ajax-cart-trigger]"
      );
      $el.removeClass("show-mini-cart");
    },
    toggleMiniCart: function () {
      const $el = $(".mobile-header [data-ajax-cart-trigger]");

      // Removes url to the cart page so user is not redirected
      $el.attr("href", "#");

      $el.off("touchstart").on("touchstart", function (e) {
        // If user clicks inside the element, do nothing
        if (e.target.closest("[data-ajax-cart-mini_cart]")) {
          return;
        }

        // Loads content into ajaxCart container for mobile header
        window.PXUTheme.jsAjaxCart.initializeAjaxCartOnMobile();

        // If user clicks outside the element, toggle the mini cart
        $el.toggleClass("show-mini-cart");
      });
    },
    showDrawer: function () {
      if (this.cart_action != "drawer") return false;
      this.ajaxCartDrawer.addClass("is-visible");
      $(".ajax-cart__overlay").addClass("is-visible");
      this.updateView();
    },
    hideDrawer: function () {
      if (this.cart_action != "drawer") return false;
      this.ajaxCartDrawer.removeClass("is-visible");
      $(".ajax-cart__overlay").removeClass("is-visible");
    },
    removeFromCart: function (lineID, callback) {
      this.showCartLoading();
      $.ajax({
        type: "POST",
        url: "/cart/change.js",
        data: "quantity=0&line=" + lineID,
        dataType: "json",
        success: function (cart) {
          window.PXUTheme.jsAjaxCart.updateView();
        },
        error: function (XMLHttpRequest, textStatus) {
          var response = eval("(" + XMLHttpRequest.responseText + ")");
          response = response.description;
        },
      });
    },
    handleSellingPlanChange: function (eventDetail) {
      const itemKey = eventDetail.itemKey;
      const sellingPlanId = eventDetail.sellingPlanId;

      console.log("Handling selling plan change:", eventDetail);

      // Show loading state
      this.showCartLoading();

      // Get current cart state and update
      $.ajax({
        url: "/cart.js",
        type: "GET",
        dataType: "json",
        success: (cart) => {
          // Find item in cart
          const foundItem = cart.items.find((item) => item.key === itemKey);

          if (!foundItem) {
            console.error("Item not found in cart with key:", itemKey);
            this.hideCartLoading();
            alert("Item not found in cart. Please refresh and try again.");
            return;
          }

          console.log("Found item in cart:", foundItem);

          // Prepare update payload
          const updateData = {
            // id: variantId || foundItem.variant_id,
            id: itemKey || foundItem.key,
            quantity: foundItem.quantity,
          };

          // Add or remove selling plan
          if (
            sellingPlanId &&
            sellingPlanId !== "null" &&
            sellingPlanId !== null
          ) {
            updateData.selling_plan = sellingPlanId;
          } else {
            updateData.selling_plan = "";
          }

          // Update cart
          $.ajax({
            type: "POST",
            url: "/cart/change.js",
            data: updateData,
            dataType: "json",
            success: (result) => {
              console.log("Cart update result:", result);
              this.updateView();
              this.hideCartLoading();
            },
            error: (xhr) => {
              console.error("Error updating selling plan:", xhr);
              this.hideCartLoading();

              let errorMessage = "Could not update subscription. ";
              try {
                const response = JSON.parse(xhr.responseText);
                if (
                  response.message &&
                  response.message.includes("Cannot apply selling plan")
                ) {
                  errorMessage += "This product may not support subscriptions.";
                } else {
                  errorMessage += "Please try again.";
                }
              } catch (e) {
                errorMessage += "Please try again.";
              }
              alert(errorMessage);

              // Refresh to reset UI state
              this.updateView();
            },
          });
        },
        error: (xhr) => {
          console.error("Error fetching cart:", xhr);
          this.hideCartLoading();
          alert("Could not fetch cart data. Please try again.");
        },
      });
    },
    handleSubscriptionToggle: function (checkbox) {
      const itemKey = checkbox.dataset.itemKey;
      const lineItem = checkbox.dataset.lineItem;
      const variantId = checkbox.dataset.variantId;
      const isSubscription = checkbox.checked;

      // Find the selling plan select for this item
      const $product = $(checkbox).closest(".ajax-cart__product");
      const $sellingPlanSelect = $product.find(
        ".ajax-cart__selling-plan-select"
      );
      let sellingPlanId = null;

      if (isSubscription && $sellingPlanSelect.length > 0) {
        sellingPlanId = $sellingPlanSelect.val();
      }

      // Dispatch the sellingPlanChanged event
      const event = new CustomEvent("sellingPlanChanged", {
        detail: {
          itemKey: itemKey,
          lineItem: lineItem,
          sellingPlanId: sellingPlanId,
          variantId: variantId,
        },
      });
      document.dispatchEvent(event);
    },
    handleSellingPlanDropdownChange: function (selectElement) {
      const sellingPlanId = selectElement.value;
      const lineItem = selectElement.dataset.lineItem;
      const itemKey = selectElement.dataset.itemKey;
      const variantId = selectElement.dataset.variantId;

      // Also check/update the subscription toggle
      const $product = $(selectElement).closest(".ajax-cart__product");
      const $subscriptionToggle = $product.find(
        'input[name="subscription-toggle"]'
      );

      if ($subscriptionToggle.length > 0) {
        $subscriptionToggle.prop("checked", !!sellingPlanId);
      }

      // Dispatch the sellingPlanChanged event
      const event = new CustomEvent("sellingPlanChanged", {
        detail: {
          itemKey: itemKey,
          lineItem: lineItem,
          sellingPlanId: sellingPlanId,
          variantId: variantId,
        },
      });
      document.dispatchEvent(event);
    },
    showCartLoading: function () {
      $("[data-ajax-cart-content]").addClass("is-loading");
      $(".ajax-cart__form").addClass("is-loading");
      const checkoutBtns = document.querySelectorAll(
        ".ajax-cart__button.button--add-to-cart"
      );
      if (checkoutBtns.length > 0) {
        checkoutBtns.forEach((btn) => (btn.disabled = true));
      }
    },
    hideCartLoading: function () {
      $("[data-ajax-cart-content]").removeClass("is-loading");
      $(".ajax-cart__form").removeClass("is-loading");
      const checkoutBtns = document.querySelectorAll(
        ".ajax-cart__button.button--add-to-cart"
      );
      if (checkoutBtns.length > 0) {
        checkoutBtns.forEach((btn) => (btn.disabled = false));
      }
    },
    initializeAjaxCart: function () {
      window.PXUTheme.asyncView
        .load(
          window.PXUTheme.routes.cart_url, // template name
          "ajax" // view name (suffix)
        )
        .done(({ html, options }) => {
          $("[data-ajax-cart-content]").html(html.content);

          // Converting the currencies
          if (window.PXUTheme.currencyConverter) {
            window.PXUTheme.currencyConverter.convertCurrencies();
          }

          // Initialize recommended products functionality
          this.initRecommendedProducts();
        })
        .fail(() => {
          // some error handling
        });
    },
    initializeAjaxCartOnMobile: function () {
      this.toggleMiniCart();

      window.PXUTheme.asyncView
        .load(
          window.PXUTheme.routes.cart_url, // template name
          "ajax" // view name (suffix)
        )
        .done(({ html, options }) => {
          $(".mobile-header [data-ajax-cart-content]").html(html.content);

          // Initialize recommended products functionality
          this.initRecommendedProducts();
        })
        .fail(() => {
          // some error handling
        });
    },
    addToCart: function ($addToCartForm) {
      const $addToCartBtn = $addToCartForm.find(".button--add-to-cart");

      $addToCartForm.removeClass("shopify-product-form--unselected-error");

      if ($addToCartBtn[0].hasAttribute("data-options-unselected")) {
        const cartWarning = `<p class="cart-warning__message animated bounceIn">${window.PXUTheme.translation.select_variant}</p>`;

        $(".warning").remove();

        $addToCartForm
          .addClass("shopify-product-form--unselected-error")
          .find(".cart-warning")
          .html(cartWarning);

        $addToCartBtn.removeAttr("disabled").removeClass("disabled");

        $addToCartBtn.find(".icon").removeClass("zoomOut").addClass("zoomIn");

        $addToCartBtn
          .find("span:not(.icon)")
          .text($addToCartBtn.data("label"))
          .removeClass("zoomOut")
          .addClass("zoomIn");
      } else {
        $.ajax({
          url: "/cart/add.js",
          dataType: "json",
          cache: false,
          type: "post",
          data: $addToCartForm.serialize(),
          beforeSend: function () {
            $addToCartBtn.attr("disabled", "disabled").addClass("disabled");

            $addToCartBtn
              .find("span")
              .removeClass("fadeInDown")
              .addClass("animated zoomOut");
          },
          success: function (product) {
            let $el = $("[data-ajax-cart-trigger]");

            $addToCartBtn.find(".checkmark").addClass("checkmark-active");

            function addedToCart() {
              if (!isScreenSizeLarge()) {
                $el = $(".mobile-header [data-ajax-cart-trigger]");
                window.PXUTheme.scrollToTop($el);
              } else {
                $el = $("[data-ajax-cart-trigger]");
              }

              $el.addClass("show-mini-cart");

              $addToCartBtn.find("span").removeClass("fadeInDown");
            }

            window.setTimeout(function () {
              $addToCartBtn.removeAttr("disabled").removeClass("disabled");

              $addToCartBtn.find(".checkmark").removeClass("checkmark-active");

              $addToCartBtn
                .find(".text, .icon")
                .removeClass("zoomOut")
                .addClass("fadeInDown");

              $addToCartBtn.on(
                "webkitAnimationEnd oanimationend msAnimationEnd animationend",
                addedToCart
              );
            }, 1000);

            window.PXUTheme.jsAjaxCart.showDrawer();
            // window.PXUTheme.jsAjaxCart.updateView();

            if (window.PXUTheme.jsCart) {
              $.ajax({
                dataType: "json",
                async: false,
                cache: false,
                dataType: "html",
                url: "/cart",
                success: function (html) {
                  const cartForm = $(html).find(".cart__form");
                  $(".cart__form").replaceWith(cartForm);
                },
              });
            }
          },
          error: function (XMLHttpRequest) {
            let response = eval("(" + XMLHttpRequest.responseText + ")");
            response = response.description;

            const cartWarning = `<p class="cart-warning__message animated bounceIn">${response.replace(
              "All 1 ",
              "All "
            )}</p>`;

            $(".warning").remove();

            $addToCartForm.find(".cart-warning").html(cartWarning);

            $addToCartBtn.removeAttr("disabled").removeClass("disabled");

            $addToCartBtn
              .find(".icon")
              .removeClass("zoomOut")
              .addClass("zoomIn");

            $addToCartBtn
              .find("span:not(.icon)")
              .text($addToCartBtn.data("label"))
              .removeClass("zoomOut")
              .addClass("zoomIn");
          },
        });
      }
    },
    updateView: function () {
      const updateViewCallback = () => {
        window.PXUTheme.asyncView
          .load(
            window.PXUTheme.routes.cart_url, // template name
            "ajax" // view name (suffix)
          )
          .done(({ html, options }) => {
            if (options.item_count > 0) {
              const itemList = $(html.content).find(".ajax-cart__list");
              const cartDetails = $(html.content).find(
                ".ajax-cart__details-wrapper"
              );
              const recommendedProducts = $(html.content).find(
                ".ajax-cart__recommended-products"
              );

              $(".ajax-cart__list").replaceWith(itemList);
              $(".ajax-cart__details-wrapper").replaceWith(cartDetails);

              // Update recommended products if they exist
              if (recommendedProducts.length > 0) {
                $(".ajax-cart__recommended-products").replaceWith(
                  recommendedProducts
                );
              }

              $(".ajax-cart__empty-cart-message").addClass("is-hidden");
              $(".ajax-cart__form").removeClass("is-hidden");
              $("[data-ajax-cart-trigger]").addClass("has-cart-count");
              $('[data-bind="itemCount"]').text(options.item_count);
            } else {
              $(".ajax-cart__empty-cart-message").removeClass("is-hidden");
              $(".ajax-cart__form").addClass("is-hidden");
              $("[data-ajax-cart-trigger]").removeClass("has-cart-count");
              $('[data-bind="itemCount"]').text("0");
            }

            if (window.PXUTheme.currencyConverter) {
              window.PXUTheme.currencyConverter.convertCurrencies();
            }

            // Initialize recommended products functionality
            this.initRecommendedProducts();
            this.hideCartLoading();

            //written by ins
            fetch("/cart.js")
              .then((response) => {
                return response.json();
              })
              .then((cart_data) => {
                const has_subscription = cart_data.items.some(
                  (item) => item.selling_plan_allocation
                );

                let data;
                if (has_subscription) {
                  const quiz_results = JSON.parse(
                    localStorage.getItem("quiz_results")
                  );

                  if (!quiz_results) return;

                  data = {
                    attributes: {
                      ...cart_data.attributes,
                      pet_ids: quiz_results
                        .map(({ petSavedId }) => petSavedId)
                        .join(", "),
                    },
                  };
                } else {
                  data = {
                    attributes: { ...cart_data.attributes, pet_ids: "" },
                  };
                }
                fetch("/cart/update.js", {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify(data),
                });
              })
              .catch((error) => {
                console.log("==>>> ERROR z__jsAjaxCart: ", error);
              });
            //written by ins
          })
          .fail(() => {
            this.hideCartLoading();

            // some error handling
          });
      };

      this.validateBFCMPromo(updateViewCallback);
    },
    unload: function ($section) {
      // Clear event listeners in theme editor
      $(".ajax-submit").off();
      $("[data-ajax-cart-delete]").off();
      $(".recommended-product__add-button").off();
    },
    validateBFCMPromo: async function (updateViewCallback) {
      const BFCMPromoEnabled = document.getElementById(
        "bfcm-promo-enabled-true"
      );
      if (BFCMPromoEnabled) {
        // const promoGiftVariantId = 50964551926081; // ==> dev site
        // const promoGiftVariantIdBeef = 50964551958849; // ==>  dev site
        const promoGiftVariantId = 47701010514142; // ==> live site
        const promoGiftVariantIdBeef = 47701010546910; // ==>  live site
        const cart = await fetch("/cart.js").then((res) => res.json());

        if (cart.items.length > 0) {
          const giftInCartChicken = cart.items.find(
            (item) => item.variant_id === promoGiftVariantId
          );
          const giftInCartBeef = cart.items.find(
            (item) => item.variant_id === promoGiftVariantIdBeef
          );
          const giftQtyInCart =
            (giftInCartChicken ? giftInCartChicken.quantity : 0) +
            (giftInCartBeef ? giftInCartBeef.quantity : 0);
          const giftInCart = giftInCartChicken || giftInCartBeef;

          const checkCartQualifiesForGift = () => {
            // customer can qualify if contains at least one non trial item
            const containsAtLeastOneNonTrial = cart.items.some(
              (item) => !item.title.toLowerCase().includes("trial")
            );
            if (containsAtLeastOneNonTrial) {
              const totalCartValue = cart.total_price / 100;
              if (totalCartValue >= 45 && totalCartValue < 85) return 1;
              else if (totalCartValue >= 85) return 2;
              else return 0;
            } else {
              return 0;
            }
          };

          let qualifiesForGift = checkCartQualifiesForGift();

          if (giftInCart && giftQtyInCart != qualifiesForGift) {
            // ======>>> gift present but qty is different then qualify, update qty
            if (qualifiesForGift < 2 && giftInCartChicken && giftInCartBeef) {
              const updates = {
                [giftInCartChicken.key]: qualifiesForGift,
                [giftInCartBeef.key]: 0,
              };

              $.ajax({
                type: "POST",
                url: "/cart/update.js",
                data: {
                  updates: updates,
                },
                dataType: "json",
                success: (result) => {
                  console.log("Gift recipe updated in cart item.");
                  // window.PXUTheme.jsAjaxCart.updateView();
                  updateViewCallback();
                },
                error: (xhr) => {
                  console.error(
                    "Failed to update gift recipe in cart item:",
                    xhr
                  );
                },
              });
            } else {
              $.ajax({
                type: "POST",
                url: "/cart/change.js",
                data: {
                  id: giftInCart.id,
                  quantity: qualifiesForGift,
                },
                dataType: "json",
                success: (result) => {
                  console.log("Gift quantity updated in cart:", result);
                  // Update cart view (this will also update recommended products)
                  // window.PXUTheme.jsAjaxCart.updateView();
                  updateViewCallback();
                },
                error: (xhr) => {
                  console.error("Failed to update gift quantity in cart:", xhr);
                },
              });
            }
          } else if (!giftInCart && qualifiesForGift) {
            // ======>>> gift not present but qualify, add the qualify qty
            $.ajax({
              type: "POST",
              url: "/cart/add.js",
              data: {
                id: promoGiftVariantId,
                quantity: qualifiesForGift,
              },
              dataType: "json",
              success: (result) => {
                console.log("Gift added to cart:", result);
                // Update cart view (this will also update recommended products)
                // window.PXUTheme.jsAjaxCart.updateView();
                updateViewCallback();
              },
              error: (xhr) => {
                console.error("Failed to add gift to cart:", xhr);
              },
            });
          } else {
            updateViewCallback();
          }
        } else {
          updateViewCallback();
        }
      } else {
        updateViewCallback();
      }
    },
    handleGiftRecipeChange: function (selectElement) {
      this.showCartLoading();
      const selectedRecipe = selectElement.value;
      const key = selectElement.dataset.lineItemKey;
      const currentQty = parseInt(selectElement.dataset.lineItemQty, 10);
      let updates = {
        [key]: 0,
        [selectedRecipe]: currentQty,
      };
      if (selectedRecipe === "one-of-each") {
        // give one quantity for both options
        const allOptions = selectElement.querySelectorAll("option");
        updates = {
          [allOptions[0].value]: 1,
          [allOptions[1].value]: 1,
        };
      }

      $.ajax({
        type: "POST",
        url: "/cart/update.js",
        data: {
          updates: updates,
        },
        dataType: "json",
        success: (result) => {
          console.log("Gift recipe updated in cart item.");
          window.PXUTheme.jsAjaxCart.updateView();
        },
        error: (xhr) => {
          console.error("Failed to update gift recipe in cart item:", xhr);
        },
      });
    },

    // Initialize recommended products functionality
    initRecommendedProducts: function () {
      $(document).on("click", ".recommended-product__add-button", function (e) {
        e.preventDefault();
        const $button = $(this);
        let variantId = $button.data("variant-id");
        // If there is a variant dropdown, use its value
        const $productCard = $button.closest(".ajax-cart__recommended-product");
        const $variantSelect = $productCard.find(
          ".recommended-product__variant-select"
        );
        if ($variantSelect.length > 0) {
          variantId = $variantSelect.val();
        }
        if ($button.prop("disabled")) return;
        // Show loading state
        $button.prop("disabled", true);
        $button.html(
          '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" opacity="0.3"/><path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><animateTransform attributeName="transform" attributeType="XML" type="rotate" from="0 12 12" to="360 12 12" dur="1s" repeatCount="indefinite"/></path></svg>'
        );
        // Add to cart
        $.ajax({
          type: "POST",
          url: "/cart/add.js",
          data: {
            id: variantId,
            quantity: 1,
          },
          dataType: "json",
          success: (result) => {
            console.log("Recommended product added to cart:", result);
            // Show success feedback briefly
            $button.html(
              '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20 6L9 17l-5-5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
            );
            // Update cart view (this will also update recommended products)
            window.PXUTheme.jsAjaxCart.updateView();
            // Reset button after a short delay
            setTimeout(() => {
              $button.prop("disabled", false);
              $button.html(
                '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 5V19M5 12H19" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
              );
            }, 1000);
          },
          error: (xhr) => {
            console.error("Failed to add recommended product to cart:", xhr);
            let errorMessage = "Failed to add to cart";
            try {
              const response = JSON.parse(xhr.responseText);
              if (response.message) {
                errorMessage = response.message;
              } else if (response.description) {
                errorMessage = response.description;
              }
            } catch (e) {
              // Use default error message
            }
            alert(errorMessage);
            // Reset button
            $button.prop("disabled", false);
            $button.html(
              '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 5V19M5 12H19" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
            );
          },
        });
      });
      $(".recommended-product__variant-select").on("change", function () {
        // update the price according to currently selected variants price
        const $select = $(this);
        const selectedOption = $select.find("option:selected");
        const variantPrice = selectedOption.data("price");
        const variantComparePrice = selectedOption.data("compare-price");

        if (!variantPrice) return;

        // Find the price container for this product
        const $productCard = $select.closest(".ajax-cart__recommended-product");
        const $priceContainer = $productCard.find(
          ".recommended-product__price"
        );

        if ($priceContainer.length > 0) {
          // Format the price (assuming price is in cents)
          const formattedPrice = "$" + (variantPrice / 100).toFixed(2);

          // Update the current price
          const $currentPrice = $priceContainer.find(
            ".recommended-product__current-price"
          );
          if ($currentPrice.length > 0) {
            $currentPrice.html(formattedPrice);
          } else {
            $priceContainer.html(formattedPrice);
          }

          // Handle compare at price if it exists
          if (variantComparePrice && variantComparePrice > variantPrice) {
            const formattedComparePrice =
              "$" + (variantComparePrice / 100).toFixed(2);

            const $comparePrice = $priceContainer.find(
              ".recommended-product__compare-price"
            );
            if ($comparePrice.length > 0) {
              $comparePrice.html(formattedComparePrice).show();
            }
          } else {
            // Hide compare price if not applicable
            $priceContainer
              .find(".was_price, .recommended-product__compare-price")
              .hide();
          }

          // Re-convert currencies if currency converter is enabled
          if (window.PXUTheme.currencyConverter) {
            window.PXUTheme.currencyConverter.convertCurrencies();
          }
        }
      });
    },
  };

  /******/
})();
